<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-card v-else fill-height fluid class="payment-handler-page">
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >
      <v-tab
        v-for="item in items"
        :key="item.tab"
        v-if="checkAccess(item.access) || !item.access"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items touchless v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
        v-if="checkAccess(item.access) || !item.access"
      >
        <v-card flat>
          <component
            :is="(item.dist || 'default-report')"
            :title="item.tab"
            :url="item.url || ''"
            :headers="item.headers || []"
            :projectList="projectList || []"
            :filters="item.filters || {}"
            :nowrap="false"
            :options="item.options"
            :settings="item.settings"
            :table_size_fixed="true"
          />
        </v-card>
      </v-tab-item>
    </v-tabs-items>

  </v-card>
</template>

<style>
  .payment-handler-dt.footer-padding .v-data-footer {
    padding-right: 45px;
  }

  .payment-handler-page > .container {
    max-width: fit-content;
  }
</style>

<script>
  import { map } from 'lodash'

  export default {

    components: {
      DefaultReport: () => import('@/components/report/Default'),
      PayoutsPaymentHandler: () => import('@/components/payment-handler/Payouts'),
      WithdrawPaymentHandler: () => import('@/components/payment-handler/Withdraw'),
      PaytahWithdrawPaymentHandler: () => import('@/components/payment-handler/PaytahWithdraw'),
      ExportCsvPayoutWithdraw: () => import('@/components/payment-handler/ExportCSVPayoutWithdraw'),
      DepositPaymentHandler: () => import('@/components/payment-handler/Deposit'),
      OfflineDepositPaymentHandler: () => import('@/components/payment-handler/OfflineDeposit'),
      FindTransactionPaymentHandler: () => import('@/components/payment-handler/FindTransaction'),
    },

    data: () => ({
      tab: null,
    }),

    computed: {
      projectList: function () {
        return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      },
      items () {

        return [
          { tab: 'Withdraw', dist: 'withdraw-payment-handler' },
          { tab: 'Deposit', dist: 'deposit-payment-handler' },
          { tab: 'Offline Deposit', dist: 'offline-deposit-payment-handler', access: 'offline_deposit' },
          { tab: 'Payouts Reports', dist: 'payouts-payment-handler' },
          // { tab: 'Paytah', dist: 'paytah-withdraw-payment-handler', access: 'paytah' },
          { tab: 'CSV Payouts', dist: 'export-csv-payout-withdraw', access: [ 'paytah', 'payout' ] },
          {
            tab: 'Withdraw History',
            url: '/$v/payment_handler/withdraw_history.json',
            headers: [
              { text: 'Request', value: 'request', sortable: false, width: '30%' },
              { text: 'Response', value: 'response', sortable: false, width: '30%' },
              { text: 'Operator', value: 'operator', sortable: false, width: '8%' },
              { text: 'ID', value: 'account_transaction_id', sortable: true, width: '8%' },
              { text: 'Date', value: 'date', sortable: true, width: '10%' },
              { text: 'Paymethod', value: 'paymethod', sortable: true, width: '8%' },
              { text: 'Status', value: 'status', sortable: true, width: '6%' },
            ],
            options: {
              hideExport: true,
            },
            // access: 'withdraw_history'
          },
          {
            tab: 'Suspicious Accounts',
            url: '/$v/reports/suspicious_accounts.json',
            headers: [
              { text: 'Login', value: 'login', sortable: false },
              { text: 'Currency', value: 'currency', sortable: false },
              { text: 'Duplicates', value: 'duplicates', sortable: true },
              { text: 'Country', value: 'country', sortable: false },
              { text: 'Action Countries', value: 'country_list', sortable: false },
              { text: 'Country Mismatch', value: 'country_mismatch', sortable: false },
              { text: 'Paymethod Duplicate', value: 'paymethod_duplicate', sortable: false },
              { text: 'Accounts', value: 'paymethod_duplicate_account', sortable: false },
            ],
            options: {
              hideDate: true,
              hideExport: true,
            }
            // access: 'withdraw_history'
          },
          { tab: 'Find Transaction', dist: 'find-transaction-payment-handler' },
        ]
      }
    },
    methods: {
      checkAccess (access) {
        if (Array.isArray(access)) {
          return access.some(key => this.$store.state.auth.checkAccess({ key, value: true }))
        }

        return this.$store.state.auth.checkAccess({ key: access, value: true })
      }
    }
  }
</script>


